import React from 'react';

const AboutSection: React.FC = () => {
  return (
    <section id="about" className="relative py-16 md:py-24 overflow-hidden section-backdrop-light">
      <div className="section-grain" aria-hidden="true" />
      <div className="container relative mx-auto px-3 sm:px-4 lg:px-6">
        <div className="mb-12 md:mb-16">
          {/* ≤1024px: number next to the line */}
          <div className="flex items-center lg:hidden mb-3">
            <span className="font-mono text-xs tracking-widest text-foreground/60 mr-2">[ 06 ]</span>
            <div className="w-20 border-t-2 border-foreground" />
          </div>
          {/* >1024px: original layout */}
          <div className="hidden lg:flex flex-row items-baseline">
            <span className="font-mono text-xs tracking-widest text-foreground/60 mr-6">[ 06 ]</span>
            <div>
              <div className="w-20 border-t-2 border-foreground mb-4"></div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-extrabold leading-tight">Mission-Driven Technology</h2>
            </div>
          </div>
          <div className="lg:hidden">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-extrabold leading-tight">Mission-Driven Technology</h2>
          </div>
        </div>

        {/* Content grid */}
        <div className="grid grid-cols-12 gap-6 max-w-5xl ml-auto items-start">
          {/* Left: copy */}
          <div className="col-span-12 lg:col-span-7 animate-on-scroll" data-delay="0.05s">
            <h3 className="text-2xl md:text-3xl font-display font-bold mb-4">About Paokhum</h3>
            <div className="space-y-4 text-foreground/80 leading-relaxed">
              <p className="text-base md:text-lg">
                We are a team of passionate developers and problem-solvers dedicated to creating impactful digital solutions. Our mission is to empower businesses with technology that is simple, powerful, and affordable.
              </p>
              <p className="text-sm md:text-base">
                Paokhum was founded on a simple principle: technology should be an accessible tool for growth and impact, not a barrier. We specialize in providing digital solutions for organizations that do incredible work but may not have large technical teams or budgets.
              </p>
              <p className="text-sm md:text-base">
                Our focus is on NGOs, local institutions, and small businesses. We build modern, low-maintenance websites and provide innovative solutions to make existing CCTV infrastructure securely accessible online.
              </p>
            </div>
          </div>

          {/* Right: image */}
          <div className="col-span-12 lg:col-span-5 animate-on-scroll" data-delay="0.15s">
            <div className="relative overflow-hidden border-2 border-foreground card-backdrop">
              <img
                src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1600&auto=format&fit=crop"
                alt="Team collaborating in a workspace"
                loading="lazy"
                decoding="async"
                width="1600"
                height="1066"
                className="block w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;

